import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// API URL
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// Initial state
const initialState = {
  stats: null,
  memberStats: null,
  loading: false,
  error: null,
};

// Get dashboard stats
export const getStats = createAsyncThunk(
  "stats/getStats",
  async (_, { rejectWithValue }) => {
    try {
      let url = `${API_URL}/members`;
      const memberData = await axios.get(url);
      const data = {
        totalMembers: memberData.data?.totalUsers || 0,
        activeMembers: memberData.data?.totalUsers || 0, // Assuming all members are active for simplicity
        totalTickets: 1250,
        activeGiveaways: 3,
        completedGiveaways: 12,
        recentMembers: memberData.data?.members?.slice(0, 3) || [],
        upcomingGiveaways: [
          {
            id: 1,
            title: "May Fishing Gear",
            endDate: "2023-05-31",
            entriesCount: 156,
          },
          {
            id: 2,
            name: "Summer Hunting Trip",
            endDate: "2023-08-31",
            entriesCount: 0,
          },
        ],
      };
      console.log("Fetched stats:", data);
      return data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch stats";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// Get member stats
export const getMemberStats = createAsyncThunk(
  "stats/getMemberStats",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/stats/member/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to fetch member stats";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// Stats slice
const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {
    resetStatsError: (state) => {
      state.error = null;
    },
    clearStats: (state) => {
      state.stats = null;
      state.memberStats = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get stats cases
      .addCase(getStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
        state.error = null;
      })
      .addCase(getStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get member stats cases
      .addCase(getMemberStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMemberStats.fulfilled, (state, action) => {
        state.loading = false;
        state.memberStats = action.payload;
        state.error = null;
      })
      .addCase(getMemberStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStatsError, clearStats } = statsSlice.actions;

export default statsSlice.reducer;
